export const DIETARY_OPTIONS = [
  "Vegan", "Vegetarian", "Gluten-Free", "Keto", "Paleo",
  "Dairy-Free", "Low-Carb", "High-Protein", "Nut-Free", "Low-FODMAP",
];

export function DietaryChips({ selected = [], onToggle, testidPrefix = "dietary" }) {
  return (
    <div className="flex flex-wrap gap-2">
      {DIETARY_OPTIONS.map((d) => (
        <button
          key={d}
          type="button"
          data-testid={`${testidPrefix}-${d}`}
          onClick={() => onToggle(d)}
          className={`px-3 py-1.5 rounded-full text-sm border transition-colors ${
            selected.includes(d)
              ? "bg-[#C85A32] text-white border-[#C85A32]"
              : "bg-[#FBF9F5] text-[#6E6259] border-[#E2D9CC] hover:border-[#C5B8A5]"
          }`}
        >
          {d}
        </button>
      ))}
    </div>
  );
}
